export enum SeatStatus {
	NotSet = 0,
	OnSale = 1,
	Sold = 2,
	Killed = 3,
    Reserved = 4,
    Pending = 5,
    Selected = 6,
    Hold = 7,
    Failed = 8,
    Deleted = 9
}



// WEBPACK FOOTER //
// ./src/app/models/seat-status.enum.ts